// jshint strict:false, undef:false, unused:false

/*/
	Cremastrap BS4 Plugins
	Stephen Ginn at Crema Design Studio
	Last Updated on 2022-08-11, 2025-11-03
/*/

// Cremastrap Plugins
// @codekit-append "plugins/S.js";
// @codekit-append "@cremadesign/cremastrap/plugins/crema/js/functions/arrays.js";
// @codekit-append "@cremadesign/cremastrap/plugins/crema/js-dev/tabmodal-links-2020.js";
// @codekit-append "@cremadesign/cremastrap/plugins/crema/js/console.js";
// @codekit-append "@cremadesign/cremastrap/plugins/crema/js/logo-slider/slider.js";
// @codekit-append "@cremadesign/captcha/dist/captcha.min.js";

// Project Helpers
// @codekit-append "plugins/arrays.js";
// @codekit-append "plugins/dates.js";
// @codekit-append "plugins/forms.js";
// @codekit-append "plugins/form-fetcher.js";
// @codekit-append "plugins/handle-errors.js";
// @codekit-append "plugins/autofill.js";
// @codekit-append "plugins/credit-cards.js";
// @codekit-append "plugins/load-plans.js";
// @codekit-append "plugins/navigation-lock.js";

// Third Party Plugins
// @codekit-append "slick-carousel/slick/slick.js";
// @codekit-append "imask/dist/imask.js";
